var _style, _g, _path, _g2, _path2, _ellipse, _ellipse2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 335.6 57.9",
    style: {
      enableBackground: "new 0 0 335.6 57.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFF0;}\n\t.st1{fill:#231F20;}\n\t.st2{fill:#1E0E17;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.6,29.9c0,0-27.8-28-62-28s-62,28-62,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.4,33c-0.8-0.9-1.9-1.9-2.9-2.8c-1-0.9-2.1-1.9-3.1-2.8c-2.1-1.8-4.3-3.6-6.6-5.2c-4.5-3.3-9.3-6.4-14.2-9 c-9.9-5.2-20.8-8.7-32-9.1c-11.2-0.4-22.5,2.4-33,7.1c-5.3,2.3-10.3,5.1-15.2,8.2c-4.8,3.1-9.5,6.6-13.8,10.5 c4-4.2,8.5-7.9,13.2-11.4c4.7-3.5,9.6-6.6,14.8-9.3c10.4-5.4,21.9-9.1,34-9.5c12.1-0.4,24,2.6,35,7.5c5.5,2.4,10.7,5.3,15.8,8.6 c2.5,1.6,5,3.3,7.4,5.2c1.2,0.9,2.4,1.8,3.6,2.8c1.2,1,2.3,1.9,3.5,3.1L332.4,33z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.6,29.9c0,0-27.8,28-62,28s-62-28-62-28"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,28C0,28,27.8,0,62,0s62,28,62,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-3.2,24.8c1.2-1.2,2.3-2.1,3.5-3.1c1.2-1,2.4-1.9,3.6-2.8c2.4-1.8,4.9-3.5,7.4-5.2c5-3.2,10.3-6.2,15.8-8.6 C38,0.4,49.9-2.6,62-2.2c12.1,0.4,23.6,4.1,34,9.5c5.2,2.7,10.1,5.9,14.8,9.3c4.7,3.5,9.1,7.2,13.2,11.4c-4.3-3.9-9-7.3-13.8-10.5 c-4.9-3.1-9.9-5.9-15.2-8.2C84.5,4.7,73.2,1.9,62,2.2c-11.2,0.4-22.1,3.9-32,9.1c-5,2.6-9.7,5.6-14.2,9c-2.3,1.7-4.4,3.4-6.6,5.2 c-1.1,0.9-2.1,1.8-3.1,2.8c-1,0.9-2,2-2.9,2.8L-3.2,24.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124,28c0,0-27.8,28-62,28S0,28,0,28"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 274,
    cy: 30.7,
    rx: 20.6,
    ry: 25.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 63.2,
    cy: 28.8,
    rx: 20.6,
    ry: 25.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59,9.6c0,0-10.4,4.7-10.2,15.7C48.7,25.3,51.2,18.9,59,9.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M271.3,9.6c0,0-10.4,4.7-10.2,15.7C261.1,25.3,263.5,18.9,271.3,9.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset37);
export default __webpack_public_path__ + "static/media/Asset 37.f2e8d74e.svg";
export { ForwardRef as ReactComponent };